export default __webpack_public_path__ + "static/media/moon.1cb4d3f8.png";